var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "hyperlink",
    width: 128,
    height: 128,
    x: 0,
    y: 0,
    enableBackground: "new 0 0 128 128",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M119.247,51.896L92.672,78.471c-11.673,11.678-30.661,11.672-42.329,0   c-2.674-2.664-4.695-5.729-6.146-8.984l4.668-4.67c1.416-1.418,3.141-2.311,4.956-2.763c0.805,3.019,2.314,5.89,4.682,8.257   c7.168,7.174,18.836,7.174,26.011,0l26.577-26.573c7.168-7.174,7.168-18.841,0-26.015c-7.174-7.168-18.842-7.168-26.01,0   L66.609,36.188c-4.979-1.392-10.188-1.721-15.286-1.027L76.916,9.563c11.671-11.673,30.661-11.673,42.331,0   C130.918,21.236,130.918,40.224,119.247,51.896z M8.753,118.441c11.67,11.668,30.66,11.668,42.331,0l25.593-25.6   c-5.099,0.693-10.308,0.365-15.286-1.025L42.92,110.282c-7.168,7.169-18.836,7.169-26.01,0c-7.168-7.175-7.168-18.843,0-26.017   l26.576-26.573c7.176-7.174,18.844-7.174,26.013,0c2.366,2.367,3.873,5.24,4.683,8.258c1.813-0.454,3.539-1.346,4.955-2.763   l4.668-4.671c-1.451-3.253-3.473-6.319-6.146-8.983c-11.667-11.673-30.655-11.678-42.328,0L8.753,76.107   C-2.917,87.781-2.917,106.77,8.753,118.441z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.26fe36d545a75cc41195afc6164cf214.svg";
export { ForwardRef as ReactComponent };